/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from "react";
import { Search, Filter, RefreshCw, ChevronDown } from "lucide-react";

const BookingFilters = ({
  showFilters,
  setShowFilters,
  searchTerm,
  searchInput,
  setSearchInput,
  handleSearch,
  handleSearchKeyPress,
  statusFilter,
  setStatusFilter,
  showStatusDropdown,
  setShowStatusDropdown,
  onResetFilters,
}) => {
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowStatusDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setShowStatusDropdown]);

  if (!showFilters) return null;

  const statusOptions = [
    "All Statuses",
    "New",
    "In Progress",
    "Work Started",
    "Completed",
    "Cancelled",
  ];

  const getStatusValue = (option) => {
    if (option === "All Statuses") return "All";
    if (option === "In Progress") return "In_Progress";
    if (option === "Work Started") return "Work_Started";
    return option;
  };

  const getStatusLabel = (value) => {
    if (value === "All") return "All Statuses";
    if (value === "In_Progress") return "In Progress";
    if (value === "Work_Started") return "Work Started";
    return value;
  };

  return (
    <div className="bg-card dark:bg-dark-surface p-2 rounded-3xl shadow-sm border border-gray-100 dark:border-dark-border flex flex-col md:flex-row gap-2 mb-6 animate-in fade-in slide-in-from-top-2 duration-200">
      <div className="flex-1 relative">
        <Search
          className="absolute left-3.5 top-1/2 -translate-y-1/2 text-primary"
          size={18}
        />
        <input
          type="text"
          placeholder="Search by client name..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          onKeyPress={handleSearchKeyPress}
          className="w-full pl-11 pr-4 py-2.5 rounded-2xl bg-gray-50 dark:bg-gray-900 border-none outline-none focus:ring-2 focus:ring-primary/20 text-text dark:text-dark-text placeholder-gray-400 dark:placeholder-dark-muted text-sm"
        />
      </div>

      {/* Search Button */}
      <button
        onClick={handleSearch}
        className="md:w-auto px-4 py-2.5 bg-primary hover:bg-primary/90 text-white rounded-2xl text-sm font-medium transition-colors flex items-center justify-center gap-2"
      >
        <Search size={16} />
        <span className="md:hidden">Search</span>
      </button>

      {/* Status Dropdown */}
      <div className="relative min-w-[180px]" ref={dropdownRef}>
        <button
          onClick={() => setShowStatusDropdown(!showStatusDropdown)}
          className="w-full flex items-center justify-between pl-4 pr-3 py-2.5 rounded-2xl bg-gray-50 dark:bg-gray-900 border-none outline-none text-text dark:text-dark-text text-sm font-medium hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        >
          <span>{getStatusLabel(statusFilter)}</span>
          <ChevronDown
            size={16}
            className={`text-primary transition-transform ${
              showStatusDropdown ? "rotate-180" : ""
            }`}
          />
        </button>

        {showStatusDropdown && (
          <div className="absolute top-full left-0 right-0 mt-2 bg-card dark:bg-dark-surface rounded-xl shadow-xl border border-gray-100 dark:border-dark-border p-1 z-50 animate-in fade-in zoom-in-95 duration-200">
            {statusOptions.map((option) => (
              <button
                key={option}
                onClick={() => {
                  setStatusFilter(getStatusValue(option));
                  setShowStatusDropdown(false);
                }}
                className={`w-full text-left px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  statusFilter === getStatusValue(option)
                    ? "bg-primary text-white dark:bg-primary"
                    : "text-gray-600 dark:text-dark-muted hover:bg-accent dark:hover:bg-gray-800"
                }`}
              >
                {option}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="flex gap-2 md:hidden">
        <button
          onClick={onResetFilters}
          className="flex-1 bg-card dark:bg-dark-surface text-gray-600 dark:text-dark-text px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-border text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors shadow-sm flex items-center justify-center gap-2"
        >
          <RefreshCw size={16} /> Reset
        </button>
        <button
          onClick={() => setShowFilters(false)}
          className="flex-1 bg-card dark:bg-dark-surface text-gray-600 dark:text-dark-text px-4 py-2.5 rounded-xl border border-gray-200 dark:border-dark-border text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors shadow-sm flex items-center justify-center gap-2"
        >
          <Filter size={16} /> Hide
        </button>
      </div>
    </div>
  );
};

export default BookingFilters;
